import { AssessmentType, BenchmarkChecklist, BenchmarkPeriod, Checklist } from 'types';

interface CurriculumBenchmarkChecklist extends Omit<BenchmarkChecklist, 'details'> {
  productCurriculumId: number;
  period: BenchmarkPeriod;
}

export const getCurriculumBenchmarkChecklist = (
  checklist: BenchmarkChecklist,
  productCurriculumId: number
) => {
  const { details, ...rest } = checklist as BenchmarkChecklist;
  const curriculumDetails = details.find((x) => x.productCurriculumId === productCurriculumId)!;

  return {
    ...rest,
    productCurriculumId: curriculumDetails.productCurriculumId,
    period: curriculumDetails.period,
  };
};

export const getCurriculumBenchmarkChecklists = (
  checklists: Checklist[] = [],
  productCurriculumId: number
): CurriculumBenchmarkChecklist[] =>
  checklists
    .filter(
      (checklist) =>
        checklist.type === AssessmentType.Benchmark &&
        (checklist as BenchmarkChecklist).details.some(
          (x) => x.productCurriculumId === productCurriculumId
        )
    )
    .map((checklist) =>
      getCurriculumBenchmarkChecklist(checklist as BenchmarkChecklist, productCurriculumId)
    );
